"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllTemplatesOnPlatform = getAllTemplatesOnPlatform;
exports.getDefaultTemplatesOnPlatform = getDefaultTemplatesOnPlatform;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const os_1 = tslib_1.__importDefault(require("os"));
const path_1 = tslib_1.__importDefault(require("path"));
const folder_1 = require("../../../../folder");
const templateHelper_1 = require("../../templateHelper");
function getTemplateMetadataConfig(configName, platform) {
    let jsonPath;
    const cacheSubDir = platform === teamsfx_api_1.Platform.VS ? "vs-metadata" : "metadata";
    const cachedJsonPath = path_1.default.join(os_1.default.homedir(), `.${String(teamsfx_api_1.ConfigFolderName)}`, cacheSubDir, configName);
    // Check if cached JSON exists, otherwise fallback to bundled templates folder
    if (!(0, templateHelper_1.useLocalTemplate)() && cachedJsonPath && fs_extra_1.default.pathExistsSync(cachedJsonPath)) {
        jsonPath = cachedJsonPath;
    }
    else {
        jsonPath = path_1.default.join((0, folder_1.getTemplatesFolder)(), "metadata", configName);
    }
    const content = fs_extra_1.default.readFileSync(jsonPath, "utf-8");
    return JSON.parse(content);
}
// used by programming language question options filter
function getAllTemplatesOnPlatform(platform) {
    const allTemplates = getTemplateMetadataConfig("allTemplates.json", platform);
    switch (platform) {
        case teamsfx_api_1.Platform.VSCode:
            return allTemplates.filter((t) => t.language !== "csharp");
        case teamsfx_api_1.Platform.VS:
            return allTemplates.filter((t) => t.language === "csharp");
        case teamsfx_api_1.Platform.CLI:
            return allTemplates;
        default:
            return [];
    }
}
// used by default generator
function getDefaultTemplatesOnPlatform(platform) {
    const defaultGeneratorTemplates = getTemplateMetadataConfig("defaultGeneratorTemplates.json", platform);
    switch (platform) {
        case teamsfx_api_1.Platform.VSCode:
            return defaultGeneratorTemplates.filter((t) => t.language !== "csharp");
        case teamsfx_api_1.Platform.VS:
            return defaultGeneratorTemplates.filter((t) => t.language === "csharp");
        case teamsfx_api_1.Platform.CLI:
            return defaultGeneratorTemplates;
        default:
            return [];
    }
}
//# sourceMappingURL=index.js.map